import { FlowDevelopComponent } from './develop.component';

export default FlowDevelopComponent;
